import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SxProps } from '@mui/system';

import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import BaseButton from 'reservations/base/components/BaseButton';
import { getWaitlistButtonTextStyles } from 'reservations/brand/helpers/v1/styles';
import { useWaitlist } from 'reservations/waitlist/providers/WaitlistProvider';

type JoinWaitlistButtonVariant = 'outlined' | 'default';

type JoinWaitlistButtonProps = {
  showNumberOfPartiesAhead?: boolean;
  onClick: (..._args: unknown[]) => void;
  sxProps?: SxProps;
  variant?: JoinWaitlistButtonVariant;
};

function getFormattedPositionOnList(waitCount: number): string {
  if (waitCount === 1) {
    return '1 party on the list';
  }

  return `${waitCount} parties on the list`;
}

function JoinWaitlistPartiesOnListText() {
  const { waitCount } = useWaitlist();
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  return (
    <Typography
      sx={theme =>
        getWaitlistButtonTextStyles(theme, hasBrandEngineFeature, true)
      }
    >
      {getFormattedPositionOnList(waitCount)}
    </Typography>
  );
}

function JoinWaitlistButton({
  onClick,
  sxProps = {},
  showNumberOfPartiesAhead = false,
  variant = 'default'
}: JoinWaitlistButtonProps) {
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();
  if (variant === 'outlined') {
    return (
      <Box>
        <BaseButton
          variant="outlined"
          onClick={onClick}
          sxProps={{ border: 2, ...sxProps }}
          label={
            <Box>
              <Typography
                sx={theme =>
                  getWaitlistButtonTextStyles(theme, hasBrandEngineFeature)
                }
              >
                Join Waitlist
              </Typography>
              {showNumberOfPartiesAhead && <JoinWaitlistPartiesOnListText />}
            </Box>
          }
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        rowGap: '10px'
      }}
    >
      <BaseButton sxProps={sxProps} label="Join Waitlist" onClick={onClick} />
      {showNumberOfPartiesAhead && <JoinWaitlistPartiesOnListText />}
    </Box>
  );
}

export default JoinWaitlistButton;
